import Joi from 'joi';

const AssignmentActionValidator = {
  schema: Joi.object({
    Status: Joi.number().required(),
    Comment: Joi.string().allow('')
  })
};

export default AssignmentActionValidator;
